// ante-react-kit/src/components/AntQuickPopup/utils/resolveEditor.js
import AntCondition from '../../../utils/AntCondition';

/**
 * Resolve editorName/editorType từ FE registry.
 *
 * @param {Object} args
 * @param {string|Array} args.editorName  - Tên trong init-editors (có thể Array conditional)
 * @param {string} args.editorType        - Inline override
 * @param {Object} args.data              - Record hiện tại (để evaluate conditional)
 * @param {Object} args.session
 * @param {Array}  args.editors           - Registry data (từ AntConfig hoặc context)
 * @returns {{type: string, lookup?: object}|null}
 */
export default function resolveEditor({ editorName, editorType, data, session, editors }) {
    // Inline editorType override
    if (editorType && !editorName) {
        return { type: editorType };
    }

    if (!editorName) return null;

    // Array conditional pattern: [{ when, value }, ..., { value: defaultName }]
    let resolvedName = editorName;
    if (Array.isArray(editorName)) {
        for (const entry of editorName) {
            if (!entry.when || AntCondition.isValid(data, { when: entry.when })) {
                resolvedName = entry.value;
                break;
            }
        }
    }

    if (typeof resolvedName !== 'string') return null;

    const found = (editors || []).find((e) => e.name === resolvedName);
    if (!found) return { type: editorType || 'antTextBox' };

    // Allow inline editorType to override registry type
    return {
        ...found,
        type: editorType || found.type
    };
}
